import { MetaTagsHelper } from 'app/utils/metaTags/metaTagsHelper';
import { Component, TemplateRef, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { NavigationService } from 'app/utils/navigation/navigation.service';
import { NemIdService } from 'app/utils/nemid/nemid.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { AppConfigService } from 'app/utils/appconfig/app-config.service';

@Component({
    moduleId: module.id,
    selector: 'next-login',
    templateUrl: './selfcare-login.component.html',
    styleUrls: ['./selfcare-login.component.less'],
})
export class SelfcareLoginComponent implements OnInit, OnDestroy {
    bsModalRef: BsModalRef;
    status: string;
    failedGetTasksAttempts = 0;
    redirectRelativeUrl: string;
    useMitId: boolean;

    subscriptions: Subscription[] = [];

    constructor(
        private router: Router,
        private nemIdService: NemIdService,
        private navService: NavigationService,
        private modalService: BsModalService,
        private translateService: TranslateService,
        private metaTagsHelper: MetaTagsHelper,
        private appConfigService: AppConfigService
    ) {
        this.metaTagsHelper.setTitleAndMetaTags('META.SELFCARE_LOGIN');
    }

    openModal(template: TemplateRef<any>) {
        this.bsModalRef = this.modalService.show(template);
    }

    ngOnInit() {
        this.useMitId = this.appConfigService.appConfig.useMitId;

        this.subscriptions.push(
            this.nemIdService.statusGet().subscribe((resp) => {
                this.status = this.translateService.instant('PAGE.SELFCARE_LOGIN.NEM_ID_STATUS.' + resp.state);
            })
        );

        this.redirectRelativeUrl = this.navService.getUrl('selfcare-landing');
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach((s) => s.unsubscribe());
    }

    nemIdLoginComplete() {
        this.router.navigateByUrl(this.redirectRelativeUrl);
    }
}
